<template>
  <div>

    <b-modal v-model="showCalculateModal" :title="$t('route.autoRouting')" @ok="okPressed" @cancel="cancelPressed" @hidden="resetModal">
      <span class='listsmall'>{{ $t('routes.from') }}:</span> {{ startPointName }}<br>
      <span class='listsmall'>{{ $t('routes.to') }}:</span> {{ finishPointName }}<br>
      <span class='listsmall'>{{ $t('routes.nogo') }}:</span> {{ routesStore.getShipNoGo }} {{$t('route.m')}} (<a href="#" @click="changeSettings()">{{ $t('routes.change') }}</a>)<br>
      <span class='listsmall'>{{ $t('routes.draught') }}:</span> {{ routesStore.getShipDraught }} {{$t('route.m')}} (<a href="#" @click="changeSettings()">{{ $t('routes.change') }}</a>)<br>
      <span class='listsmall'>{{ $t('routes.route') }}:</span> {{ routesStore.getShipUsegeneralroutes ? $t('route.general') :  $t('route.detailed') }} (<a
        href="#" @click="changeSettings()">{{ $t('routes.change') }}</a>)

    </b-modal>
    <b-container fluid>
<!--
      <b-row v-if="isDevBuild()">
        <b-col>
          <b-form-checkbox size="sm" v-model="useGeneralRoute">
            <span class="smt2s">Calculate general route</span>
          </b-form-checkbox>
        </b-col>
      </b-row>      

      <b-row v-if="isDevBuild()">
        <b-col>
          <b-form-checkbox size="sm" v-model="useGlobalRoute">
            <span class="smt2s">Calculate big data route</span>
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row v-if="isDevBuild()">
        <b-col>
          <div>
            <span class="smt2s">Fuzzy search threshold</span>            
          </div>
          <div>
            <span class="smt10px">0 - hard match, 1 - soft match</span>
          </div>
          <div>
            <b-form-input type="range" min="0" step="0.04" max="1" v-model="searchThreshold"/>
          </div>
        </b-col>
      </b-row>
    -->
      <b-row>
        <b-col>
          <b-form-group>
            <b-input-group size="sm">
              <b-form-input
                  id="filter-input"
                  v-model="searchFilter"
                  debounce="200"
                  type="search"
                  :placeholder="$t('route.typeToSearch')"
                  @input="onStartFilter"
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="light" :disabled="!searchFilter" @click="searchFilter = ''">{{ $t('routes.clear') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <div v-show="!busyFlag">
        <b-row>
          <b-col>
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
        <b-row class="ports-table">
          <b-col>
            <b-table selectable select-mode="single" primary-key="compositeKey" ref="searchOnTable" :per-page="perPage"
                     :current-page="currentPage" :items="portsWithValidation" :fields="visible_fields"
                     @row-selected="onRowSelected" @filtered="onFiltered">

              <template #cell(name)="row">
                {{ row.item.name }}
                <span class="small-gray"> ({{ row.item.country }})</span>
                <div class="port-warning-div" v-if="row.item.hasDepthWarning">
                  <b-icon icon="exclamation-triangle"/>
                  <span>{{ row.item.depthWarning }}</span>
                </div>
              </template>

              <template #cell(start)="row">
                <div v-if="checkPort(row) && !hasStartPoint && finishPoint !== row.item">
                  <b-button size="sm" variant="success" @click="addPort(PORT_TYPES.START, row)">
                    <b-icon icon="flag"></b-icon>
                  </b-button>
                </div>
                <div v-else>
                  <b-button v-if="startPoint === row.item" @click="removePort(PORT_TYPES.START)"
                            size="sm">
                    <b-icon icon="flag"></b-icon>
                  </b-button>
                </div>
              </template>

              <template #cell(finish)="row">
                <div
                    v-if="checkPort(row) && !hasFinishPoint && startPoint !== row.item">
                  <b-button size="sm" variant="warning" @click="addPort(PORT_TYPES.FINISH, row)">
                    <b-icon icon="flag"></b-icon>
                  </b-button>
                </div>
                <div v-else>
                  <b-button v-if="finishPoint === row.item"
                            @click="removePort(PORT_TYPES.FINISH)" size="sm">
                    <b-icon icon="flag"></b-icon>
                  </b-button>
                </div>
              </template>

            </b-table>
          </b-col>
        </b-row>
      </div>
      <div align="center" class="text-sm-centercenter text-danger my-2" v-show="busyFlag">
        <b-spinner small class="align-middle"></b-spinner>
        <strong>&nbsp;{{ $t('routes.searching') }}</strong>
      </div>
    </b-container>
  </div>
</template>

<script>
import {eventBus, routes_map} from "@/main";
import store from "@/store";
import Vue from "vue";
import L from "leaflet";
import * as waypoints from "@/my-leaf/routes/components/route-waypoints";
import {drawFromToPoints} from "@/my-leaf/routes/components/route-waypoints";
import {mapStores} from "pinia";
import {useRoutesStore} from "@/stores/routes";
import {useMomentaryStore} from "@/stores/momentary";
import Fuse from "fuse.js";
import { GeoUtils } from "@/utils/geo-utils";

let portsJSON = require("@/data/ports.json");

export default {
  name: "Search",
  data() {
    return {
      ports: portsJSON,
      busyFlag: false,
      searchFilter: '',
      aaa: null,
      filterOn: ['name'],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [5, 10, 15, {value: 100, text: "Show a lot"}],
      //routePorts: ["", ""],
      //routePortsObjects: [null, null],
      //routePortsCoordinates: [null, null],
      PORT_TYPES: {START: 0, FINISH: 1},
      showCalculateModal: false,
      useGlobalRoute: false,
      useGeneralRoute: true,
      history: [],
      skipParamsDialog: false,
      okClicked: false,
      searchThreshold: 0.4,
      routes_map: routes_map
    }
  },
  mounted() {
    this.totalRows = this.ports.length

    eventBus.$off('port-clicked')
    eventBus.$on('port-clicked', (name) => {
      this.searchFilter = name
    })

    const routeCleared = () => {
      //this.routePorts = ["", ""];
      //this.routePortsObjects = [null, null];
      //this.routePortsCoordinates = [null, null];
      this.removeSearchFilter();
      this.showCalculateModal = false;
    };

    eventBus.$off('route-preview-cleared');
    eventBus.$off('route-cleared');
    eventBus.$on('route-preview-cleared', routeCleared);
    eventBus.$on('route-cleared', routeCleared);   
  },
  methods: {
    isDevBuild() {
      return process.env.VUE_APP_DEVBUILD === 'true';
    },
    onStartFilter() {
    },
    onRowSelected(items) {
      if (!items?.length) return;
      
      let coordinates = {lat: items[0].lat, lon: items[0].lon}

      routes_map.panToCoordinates(coordinates)
      // eventBus.$emit('show-from-search', {lat: lat, lon: lon})
      this.$refs.searchOnTable.clearSelected()
      this.$root.$emit('bv::toggle::collapse', 'search-sidebar')
    },
    onFiltered(filteredItems) {
      this.totalRows = this.ports.length
      this.currentPage = 1
      this.busyFlag = false;
    },
    removeSearchFilter() {
      this.searchFilter = ''
    },
    changeSettings() {
      this.showCalculateModal = false
      this.$parent.$parent.$parent.showSettings()
    },
    addPort(portType, row) {

      // let ports = portsJSON
      // let i = 0
      // ports.forEach((item1) => {
      //   item1.id = i++
      //   // console.log("aaaa", item1)
      // })
      // // console.log("aaaa", ports)
      //
      // function download(content, fileName, contentType) {
      //   var a = document.createElement("a");
      //   var file = new Blob([content], {type: contentType});
      //   a.href = URL.createObjectURL(file);
      //   a.download = fileName;
      //   a.click();
      // }
      // download(JSON.stringify(ports), 'json.txt', 'text/plain');


      console.log("aaa", portType, row)

      if (!this.hasStartPoint && !this.hasFinishPoint) {
        routes_map.clearGeneralRoute();
        routes_map.clearRoute()
      }

      let coordinates = {lat: row.item.lat, lon: row.item.lon}

      waypoints.addWP.call(
        routes_map, 
        L.latLng(coordinates.lat, coordinates.lon),
        -2,
        { 
          portType,
          port: row.item
        }
      );
      // TODO: separate bypass mode
      routes_map.isBaypassMode = true;
      // eventBus.$emit('show-from-search', coordinates)
      routes_map.panToCoordinates(coordinates)

      eventBus.$emit('draw-map-layers')
      //Vue.set(this.routePorts, portType, row.item.name)
      //Vue.set(this.routePortsObjects , portType, row.item);
      //Vue.set(this.routePortsCoordinates, portType, coordinates)
      this.removeSearchFilter()

      //routes_map.drawStartFinish(coordinates, portType)
      
      if (this.hasStartPoint && this.hasFinishPoint) {
        this.showCalculateModal = true;
      }
    },
    removePort(portType) {
      //Vue.set(this.routePorts, portType, "")
      //Vue.set(this.routePortsCoordinates, portType, null)
      
      if (!this.routes_map || !this.routes_map.waypoints) return;
      const index = this.routes_map.waypoints.findIndex(p => p.options.portType == portType)
      if (index < 0) return;

      waypoints.removeWP.call(this.routes_map, index);

      this.removeSearchFilter()
    },
    checkPort(row) {
      let port = row.item;

      if (!this.hasStartPoint && port !== this.startPoint ||
          !this.hasFinishPoint && port !== this.finishPoint)
        return true
      else
        return false
    },
    okPressed() {
      eventBus.$emit('show-waypoints')
      this.removeSearchFilter()
      this.okClicked = true;
      this.history = [{
        routePorts: [...this.routePorts],
        routePortsCoordinates: [...this.routePortsCoordinates]
      }];

      //eventBus.$emit('draw-start-finish', this.routePortsCoordinates[0], this.routePortsCoordinates[1])
      this.recalculatePortRoute();      
    },
    recalculatePortRoute() {
      if (!this.useGlobalRoute && !this.useGeneralRoute)
        return;
      if (this.useGlobalRoute && !this.useGeneralRoute) {
          this.calculateGlobalRoute();
          return;
      }

      const startPort = this.startPoint;// this.routePortsObjects[this.PORT_TYPES.START] ?? this.ports.find(port => port.name === this.routePorts[this.PORT_TYPES.START]);
      const finishPort = this.finishPoint;// this.routePortsObjects[this.PORT_TYPES.FINISH] ?? this.ports.find(port => port.name === this.routePorts[this.PORT_TYPES.FINISH]);

      routes_map.portsRouteAsync({
        startPort, 
        finishPort,
        routePorts: this.routePorts, 
        routePortsCoordinates: this.routePortsCoordinates,
        globalRoute: this.useGlobalRoute
      });

      //if (!this.useGlobalRoute) {
      //  this.routePorts = ["", ""]
      //  this.routePortsObjects = [null, null];
      //  this.routePortsCoordinates = [null, null]
      //}
    },
    resetModal() {
      if (this.okClicked) {
        this.okClicked = false;
        return;
      }

      // at this stage we assume that dialog was closed by pressing Cancel button or via click on backdrop
      this.cancelPressed();
    },
    cancelPressed() {
      //this.routePorts = ["", ""];
      //this.routePortsObjects = [null, null];
      //this.routePortsObjects = [null, null];
      this.searchFilter = '';
      this.history = [];
      routes_map.clearRoute(true, true);
    },
    calculateGlobalRoute() {
      store.commit("fickle/setGlobalRoute", {ports: this.routePorts, coordinates: this.routePortsCoordinates})
      routes_map.clearRoute(true, true);

      //this.routePorts = ["", ""]
      //this.routePortsObjects = [null, null];
    },
    filterPorts() {
      let filteredResult = portsJSON;

      if (this.searchFilter.length > 0) {
        // original search, include all ports that start with searchFilter
        filteredResult = portsJSON.filter((e) => {
          // return e.name.includes(newVal.toUpperCase())
          return e.name.startsWith(this.searchFilter.toUpperCase())
        })

        // add first 10 fuzzy search results
        const fuseOptions = {
          isCaseSensitive: false,
          includeScore: true,
          ignoreDiacritics: true,
          threshold: this.searchThreshold,
          keys: [
            "name"
          ]
        };

        const fuse = new Fuse(portsJSON, fuseOptions);
        const fuzzyResult = fuse.search(this.searchFilter).map(i => i.item);
        filteredResult = filteredResult.concat(fuzzyResult.filter(p => !filteredResult.includes(p)).slice(0, 10));
      }

      this.ports = filteredResult
      this.totalRows = filteredResult.length
    }
  },
  computed: {
    ...mapStores(useRoutesStore),
    compositeKey() {
      return this.ports.map(port => ({
        ...port,
        compositeKey: `${port.name}-${port.country}`
      }));
    },
    visible_fields() {
      return [
        // {key: 'id', label: 'ID', thClass: 'd-none', tdClass: 'd-none'},
        {key: 'name', label: this.$t('route.name'), tdClass: 'small-black', thClass: 'small-gray'},
        {key: 'start', label: this.$t('route.start'), tdClass: 'small-black', thClass: 'small-gray'},
        {key: 'finish', label: this.$t('route.finish'), tdClass: 'small-black', thClass: 'small-gray'}
      ]
    },
    portsWithValidation() {
      const noGo = this.routesStore.getShipNoGo;

      return this.ports.map(p => {
        return {
          ...p,
          hasDepthWarning: p.depth < noGo,
          depthWarning: p.depth < 0 ? `Port is on land` : `Port depth is ${p.depth} m`
        }
      })
    },
    routePorts() {
      return [this.startPointName, this.finishPointName];
    },
    routePortsCoordinates() {
      if (!this.startPoint || !this.finishPoint) return [null, null];
      return [
        {lat: this.startPoint.lat, lon: this.startPoint.lon},
        {lat: this.finishPoint.lat, lon: this.finishPoint.lon}
      ];
    },    
    startPoint() {
      if (!this.routes_map || !this.routes_map.waypoints) return null;
      return this.routes_map.waypoints.find(p => p.options.portType == this.PORT_TYPES.START)?.options?.port;
    },
    startPointName() {
      return this.startPoint?.name;
    },
    hasStartPoint() {
      return !!this.startPoint;
    }, 
    finishPoint() {
      if (!this.routes_map || !this.routes_map.waypoints) return null;
      return this.routes_map.waypoints.find(p => p.options.portType == this.PORT_TYPES.FINISH)?.options?.port;
    },
    finishPointName() {
      return this.finishPoint?.name;
    },
    hasFinishPoint() {
      return !!this.finishPoint;
    },
  },
  watch: {
    'searchFilter'(newVal) {
      this.filterPorts();
    },
    'searchThreshold'(newVal) {
      this.filterPorts();
    }, 
    'routePorts'() {
      /*
      if (this.skipParamsDialog) {
        this.skipParamsDialog = false;
        return;
      }
      if (this.routePorts[this.PORT_TYPES.START] && this.routePorts[this.PORT_TYPES.FINISH])
        this.showCalculateModal = true
      */
    },
    'useGeneralRoute'() {
      if (!this.useGeneralRoute && !this.useGlobalRoute) {
        this.useGlobalRoute = true;
      }
    },
    'useGlobalRoute'() {
      if (!this.useGeneralRoute && !this.useGlobalRoute) {
        this.useGeneralRoute = true;
      }
      /*
      console.log("useGlobalRoute", this.history);
      const history = this.history[0];

      if (history) {
        eventBus.$emit('clear-general-route-layers');
        this.skipParamsDialog = true;
        this.routePorts = [...history.routePorts];
        this.routePortsCoordinates = [...history.routePortsCoordinates];
        this.recalculatePortRoute();
      }
      */
    }
  }
}
</script>

<style scoped>
.port-warning-div {
  background-color: black;
  color: yellow;
  padding: 0px 3px;
  display: flex;
  gap: 5px;
  align-items: center;
  border-radius: .2rem;
}

.ports-table {
    height: calc(100vh - 350px);
    overflow-y: auto;
}
</style>